// Copyright 2025, University of Maryland, All Rights Reserved
import { Bug } from 'lucide-react';
import { Button } from '@umd-dit-ai-workspace/shared-ui';

interface ReportIssueButtonProps {
  email?: string;
  variant?: 'default' | 'outline' | 'ghost';
  size?: 'default' | 'sm' | 'lg' | 'icon';
  className?: string;
}

export function ReportIssueButton({ 
  email = 'dit-ais@umd.edu',
  variant = 'outline',
  size = 'sm',
  className = ''
}: ReportIssueButtonProps) {
  
  const handleReportIssue = () => {
    // Get current context
    const currentUrl = window.location.href;
    const userAgent = navigator.userAgent;
    const timestamp = new Date().toISOString();
    
    // Build email content
    const subject = encodeURIComponent('Course Align - Issue Report');
    const body = encodeURIComponent(
`Please describe the issue you encountered:

[Describe the issue here]


Expected Behavior:
[What did you expect to happen?]


Actual Behavior:
[What actually happened?]


Additional Context:
-------------------
Page URL: ${currentUrl}
Timestamp: ${timestamp}
Browser: ${userAgent}
`
    );
    
    // Open mailto link
    window.location.href = `mailto:${email}?subject=${subject}&body=${body}`;
  };

  return (
    <Button
      variant={variant}
      size={size}
      onClick={handleReportIssue}
      className={`gap-2 ${className}`}
      title="Report an issue"
    >
      <Bug className="h-4 w-4" />
      <span>Report Issue</span>
    </Button>
  );
}
